import React, { useEffect, useState } from 'react';
import { axios } from '../../axios'
import { Link, useNavigate } from 'react-router-dom'

const Cotizaciones = () => {

	const [cotizaciones, setCotizaciones] = useState([])
	const navigate = useNavigate()

	useEffect(()=>{
		axios.get('/api/seller_quotes')
		.then(r=>{
			setCotizaciones(r.data)
		})
		.catch(e=>{
			if(e.response.data.error==='uncompleted'){
				alert(e.response.data.message)
				navigate('/mis-datos')
			}else{
				alert(e)
			}
		})
		
	},[])

	const _cotizacion = (cotizacion_id) => {
		navigate(`/cotizacion/${cotizacion_id}`)
	}

	return (
		<div className='card-panel'>
			<h4>Quotes</h4>
			<table>
				<thead>
					<tr>
						<th>Quote</th>
						<th>Product Item_no</th>
						<th>Product</th>
						<th>Quantity</th>
						<th>Destination quote</th>
						<th>Date</th>
					</tr>
				</thead>

				<tbody>
					{cotizaciones.map((c,i)=>
					<tr key={i} style={{cursor:'pointer'}} onClick={()=>_cotizacion(c.id)}>
						<td>Quote-{String(c.id).padStart(4, 0)}</td>
						<td>{c.item_no}</td>
						<td>{c.object_ref.producto?.nombre}</td>
						<td>{c.cantidad}</td>
						<td>{c.object_ref.cotizacion?.country}</td>
						<td>{new Date(c.created_at).toLocaleString('es-MX', { timeZone: "America/Mexico_City" })}</td>
					</tr>
					)}
				</tbody>
			</table>
		</div>
	)

}

export default Cotizaciones
